<template>
  <div>
    <div class="cooperation_wrap">
      <div class="cooperation_tit">客户案例</div>
      <div class="cooperation_desc">
        多种不同合作案例，让您看到我们的服务，见证巨航实力
      </div>
      <div class="cooperation_box">
        <div class="cooperation_item">
          <el-carousel direction="vertical" loop>
            <el-carousel-item
              v-for="(item, index) in customerList"
              :key="index"
            >
              <div class="cooperation_item-customer" @click="showDetail(index)">
                <img :src="item.img" loading="lazy" />
                <div class="cooperation_item-customer-info">
                  <p class="name">{{ item.name }}</p>
                  <p class="button">了解更多 >></p>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="cooperation_bottom">
      <div class="details_show">
        <div class="show_item">
          <div class="show_top">22个</div>
          <div class="show_bottom">省份</div>
        </div>
        <div class="show_item">
          <div class="show_top">40+</div>
          <div class="show_bottom">城市</div>
        </div>
        <div class="show_item">
          <div class="show_top">1500+</div>
          <div class="show_bottom">服务大厅</div>
        </div>
        <!-- <div class="show_item">
          <div class="show_top">数万家</div>
          <div class="show_bottom">企业</div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      customerList: [
      ],
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      const baseUrl = process.env.NODE_ENV === 'production'
        ? process.env.VUE_APP_PUBLIC_PATH
        : '/'

      fetch(baseUrl + '/customer/data.json')
        .then(response => response.json())
        .then(data => {
          this.customerList = data.customers
        })
        .catch(error => console.error('Error loading JSON:', error));
    },
    showDetail(index) {
      console.log("click showDetail", index)
      this.$router.push('/customer/' + (index + 1))
    }
  },
  beforeRouteUpdate(to, from, next) {
    console.log('路由参数变化：', to.path);
    next(); // 必须调用 next() 才能继续路由跳转
  },
  watch: {
    '$route'(to, from) {
      // to: 新的路由对象
      // from: 旧的路由对象
      console.log('路由变化：', to.path);
      console.log('从：', from.path, '到：', to.path);
    }
  }
}
</script>

<style lang="scss" scoped>
.cooperation_wrap {
  width: 100%;
  text-align: center;
  background: url("../../assets/img/bottom_bg.90c1ea1.jpg") 0 0 no-repeat;
  background-size: 100% 100%;
  padding-bottom: 60px;
  @media screen and (max-width: 768px) {
    padding-bottom: 10px;
  }
  .cooperation_tit {
    font-size: 40px;
    font-weight: bold;
    color: #3e3e3e;
    padding-top: 50px;
    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
      padding-top: 20px;
    }
  }
  .cooperation_desc {
    color: rgba(32, 48, 64, 0.75);
    font-size: 22px;
    margin-top: 30px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      margin-top: 10px;
    }
  }
  .cooperation_box {
    width: 70%;
    margin: 0 auto;
    padding-top: 50px;
    position: relative;
    @media screen and (max-width: 768px) {
      width: 90%;
      padding-top: 20px;
    }
    .cooperation_item {
      .el-carousel {
        height: 300px;
        @media screen and (max-width: 768px) {
          height: 200px;
        }
      }
      .el-carousel__item .cooperation_item-customer {
        height: 100%;
        display: flex;
        margin: 0;
      }
      .cooperation_item-customer img {
        // width: 100%;
        height: 100%;
        object-fit: cover;
        // mask: linear-gradient(to bottom, transparent, black); /* 渐变遮罩 */
        flex: 3;
        @media screen and (max-width: 768px) {
          height: 200px;
        }
      }
      .cooperation_item-customer .cooperation_item-customer-info {
        flex: 1;
        background: #002f7d;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        p {
          color: #fff;
          &.name {
            font-weight: 600;
            font-size: 2.4em;
            margin-bottom: 1em;
          }
          &.button {
            width: 180px;
            height: 50px;
            line-height: 50px;
            border-radius: 50px;
            border: 1px solid #fff;
          }
        }
      }

      .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
      }

      .el-carousel__item:nth-child(2n + 1) {
        background-color: #d3dce6;
      }
    }
    .change_page {
      position: absolute;
      bottom: 40px;
      right: 40px;
      @media screen and (max-width: 768px) {
        bottom: 5px;
        right: 5px;
      }
    }
  }
}
.cooperation_bottom {
  width: 100%;
  height: 300px;
  @media screen and (max-width: 768px) {
    height: 40px;
  }
  background: url("../../assets/img/bannershow.png") 0 0 no-repeat;
  background-size: contain;
  .details_show {
    width: 70%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 768px) {
      width: 90%;
    }
    .show_item {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .show_top {
        color: #717171;
        font-size: 50px;
        font-weight: bold;
        @media screen and (max-width: 768px) {
          font-size: 12px;
        }
      }

      .show_bottom {
        color: #717171;
        font-size: 25px;
        margin-top: 10px;
        @media screen and (max-width: 768px) {
          font-size: 12px;
          margin-top: 0px;
        }
      }
    }
  }
}
</style>